module.exports = __webpack_public_path__ + "static/media/GooglePlayBadge.daf82f63.png";